(() => {
    const popUpTariffFunction = () => {
        const popUpLinks = document.querySelectorAll('.electricity__tarif-details .data-popup[data-popup-content]');

        if (popUpLinks) {
            popUpLinks.forEach((popUp) => {
                popUp.addEventListener('focus', (e) => {
                    e.preventDefault();
                    const consumption = parseInt(document.querySelector('.electricity-yearly input').value);
                    const details = e.target.parentNode.querySelector('.electricity__tarif-details-popup-content');
                    let popUpContent = details.outerHTML;

                    const prices = JSON.parse(
                        details.closest('[data-component="electricity-tariff-choice"]').dataset.prices
                    );

                    const matchingPrice = prices.find(
                        (price) => consumption >= price.consumptionFrom && consumption <= price.consumptionTo
                    );

                    if (!matchingPrice) return;

                    const {
                        apBrutto,
                        apNetto,
                        gpBrutto,
                        gpNetto,
                        bonusDirect,
                        bonusNewCustomer,
                        consumptionFrom,
                        consumptionTo,
                    } = matchingPrice;

                    let apYear = (consumption * apBrutto) / 100;
                    let bpYear = (consumption * apBrutto) / 100 + gpBrutto;
                    let priceYear = (consumption * apBrutto) / 100 + gpBrutto - bonusDirect - bonusNewCustomer;

                    popUpContent = popUpContent
                        .replace(/#CONSUMPTION#/, consumption)
                        .replace(/#CONSUMPTIONFROM#/, consumptionFrom)
                        .replace(/#CONSUMPTIONTO#/, consumptionTo)
                        .replace(/#APBRUTTO#/g, apBrutto.toLocaleString('de-DE'))
                        .replace(/#APNETTO#/g, apNetto.toLocaleString('de-DE'))
                        .replace(/#GPBRUTTO#/g, gpBrutto.toLocaleString('de-DE'))
                        .replace(/#GPNETTO#/g, gpNetto.toLocaleString('de-DE'))
                        .replace(/#APYEAR#/, apYear.toLocaleString('de-DE'))
                        .replace(/#BPYEAR#/, bpYear.toLocaleString('de-DE'))
                        .replace(/#BONUSDIRECT#/, bonusDirect.toLocaleString('de-DE'))
                        .replace(/#BONUSNEWCUSTOMER#/, bonusNewCustomer.toLocaleString('de-DE'))
                        .replace(/#PRICEYEAR#/, priceYear.toLocaleString('de-DE'));

                    e.target.setAttribute('data-popup-content', popUpContent);
                });
            });
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        popUpTariffFunction();
    });
})();
